import { Children } from 'react';
import clsx from 'clsx';

import type { BoxProps } from '../../Box/Box';
import { Box } from '../../Box/Box';

import { row, selected as styles_selected } from '../../../../components/Table/Row/styles.css';

export interface Props extends Omit<BoxProps, 'cssClass'> {
  children: React.ReactNode;
  gridColumns?: string[];
  selected?: boolean;
  className?: string;
  forwardRef?: React.Ref<HTMLDivElement>;
}

export const Row: React.FC<Props> = ({ children, gridColumns, selected, forwardRef, className, ...boxProps }) => {
  const childrenArray = Children.toArray(children);
  const defaultGridTemplateColumns = childrenArray.map(() => '1fr').join(' ');

  return (
    <Box
      ref={forwardRef}
      cssClass={clsx(row, className, {
        [styles_selected]: selected,
      })}
      cursor={boxProps.onClick ? 'pointer' : undefined}
      style={{
        gridTemplateColumns: gridColumns ? gridColumns.join(' ') : defaultGridTemplateColumns,
      }}
      {...boxProps}
    >
      {children}
    </Box>
  );
};
